import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b638249"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "settings" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "btn-settings text",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage('en')))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["square", { full: _ctx.currentLang === 'en', light: !_ctx.darkMode }])
      }, null, 2),
      _createTextVNode(" EN ")
    ]),
    _createElementVNode("div", {
      class: "btn-settings text",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('fr')))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["square", { full: _ctx.currentLang === 'fr', light: !_ctx.darkMode }])
      }, null, 2),
      _createTextVNode(" FR ")
    ]),
    _createElementVNode("div", {
      class: "btn-settings text",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleDarkMode(true)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["square", { full: _ctx.darkMode, light: !_ctx.darkMode }])
      }, null, 2),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("settings.dark")), 1)
    ]),
    _createElementVNode("div", {
      class: "btn-settings text",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleDarkMode(false)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["square", { full: !_ctx.darkMode, light: !_ctx.darkMode }])
      }, null, 2),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("settings.light")), 1)
    ])
  ]))
}